import React, {useEffect, useRef} from "react";
import "@arcgis/core/assets/esri/themes/light/main.css";
import {Tabs, TabsContent, TabsList, TabsTrigger} from "../components/ui/Tabs";
import Analysis from "../components/dashboard/Analysis";
import {Card, CardContent} from "../components/ui/Card";
import {Link, useParams} from "react-router-dom";
import "@chatscope/chat-ui-kit-styles/dist/default/styles.min.css"
import Chat from "../components/dashboard/Chat";
import {loadModules} from "esri-loader";
import piezometerLocations from "../data/piezometerLocation.json";
import Support from "../components/dashboard/Support";

function HomePage() {
    const {tabId} = useParams();
    const {userId} = useParams();

    const mapRef = useRef(null);

    useEffect(() => {
        let view;

        loadModules(["esri/Map", "esri/views/MapView", "esri/Graphic", "esri/layers/GraphicsLayer"], {
            css: true
        }).then(([Map, MapView, Graphic, GraphicsLayer]) => {
            const map = new Map({
                basemap: "satellite",
            });

            view = new MapView({
                container: mapRef.current,
                map: map,
                center: [29.8843851, -24.2987158], // Center based on dataset
                zoom: 16
            });

            const graphicsLayer = new GraphicsLayer();
            map.add(graphicsLayer);

            piezometerLocations.forEach((pz) => {
                const point = {
                    type: "point",
                    longitude: parseFloat(pz.longitude),
                    latitude: parseFloat(pz.latitude)
                };

                const markerSymbol = {
                    type: "simple-marker",
                    style: pz.type === "piezometer" ? "circle" : "square",
                    color: pz.type === "piezometer" ? "green" : "purple",
                    outline: { color: "white", width: 2 },
                    size: 10
                };

                const popupTemplate = {
                    title: `{pzName}`,
                    content: `Elevation: {elevation}m | Water Level: {waterLevel}m | Invert Level: {invertLevel}m | Line: {line}`,
                };

                const attributes = {
                    pzName: pz.pzName,
                    elevation: pz.elevation
                };

                const pointGraphic = new Graphic({
                    geometry: point,
                    symbol: markerSymbol,
                    attributes: attributes,
                    popupTemplate: popupTemplate
                });

                graphicsLayer.add(pointGraphic);
            });
        });

        return () => view?.destroy();
    }, [tabId]);

    return (
        <div className="bg=[#333333] py-8 h-screen">
            <Tabs defaultValue={tabId} className="w-11/12 mx-auto">
                <TabsList className="grid w-fit grid-cols-4">
                    <TabsTrigger value="overview">
                        <Link to={`/dashboard/${userId}/overview`}>Overview</Link>
                    </TabsTrigger>
                    <TabsTrigger value="analysis">
                        <Link to={`/dashboard/${userId}/analysis`}>Detail Site Information</Link>
                    </TabsTrigger>
                    <TabsTrigger value="ai-assistant">
                        <Link to={`/dashboard/${userId}/ai-assistant`}>AI Assistant</Link>
                    </TabsTrigger>
                    <TabsTrigger value="support">
                        <Link to={`/dashboard/${userId}/support`}>Help Desk</Link>
                    </TabsTrigger>
                </TabsList>
                <TabsContent value="overview">
                    <Card>
                        <div className="h-screen w-full relative rounded-3xl" ref={mapRef}></div>
                    </Card>
                </TabsContent>
                <TabsContent value="analysis">
                    <Analysis />
                </TabsContent>
                <TabsContent value="ai-assistant">
                    <Chat />
                </TabsContent>
                <TabsContent value="support">
                    <Support />
                </TabsContent>
            </Tabs>

            {/*<div className="fixed bottom-0 left-0 right-0 w-full">*/}
            {/*    <div className="bg-[#333333] mx-auto w-2/5 flex justify-between items-center align-middle px-8 py-2 rounded-t-xl text-white">*/}
            {/*        <div className="flex items-center mt-2">*/}
            {/*            <MessagesSquare color="white" />*/}
            {/*            <p className="ml-4 mt-2 text-lg font-extralight">Ask AI Assistant</p>*/}
            {/*        </div>*/}
            {/*        <div className="flex items-center border rounded-md border-solid">*/}
            {/*            <input className="w-96 px-4 py-2 text-black text-base font-light" placeholder="Short on time? Ask for a quick report..."/>*/}
            {/*            /!*<Input className="w-96 text-black rounded-r-none" placeholder="Short on time? Ask for a quick report..." />*!/*/}
            {/*            <div>*/}
            {/*                <Sheet>*/}
            {/*                    <SheetTrigger asChild>*/}
            {/*                        <Button variant="icon" className="px-4">*/}
            {/*                            <SendHorizonal/>*/}
            {/*                        </Button>*/}
            {/*                    </SheetTrigger>*/}
            {/*                    <SheetContent side="right">*/}
            {/*                        <SheetHeader>*/}
            {/*                            <SheetTitle>AI Assistant</SheetTitle>*/}
            {/*                        </SheetHeader>*/}
            {/*                    </SheetContent>*/}
            {/*                </Sheet>*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}
        </div>
    );
}

export default HomePage;